

import { Component, Vue, Watch, Prop } from "vue-property-decorator"

// @ts-ignore
import draggable from "vuedraggable"

@Component({
	components: {
		draggable
	}
})
export default class SortableTable extends Vue {
	@Prop({ type: Array, default: () => [] })
	value!: any[]

	@Prop({ type: String, default: "drag" })
	groupName!: string

	@Prop({ type: String, default: "key" })
	itemKey!: string

	@Prop({ type: Array, default: () => [] })
	columns!: { key: string, label: string }[]

	dragOptions = {
		animation: 200,
		disabled: false,
		ghostClass: "ghost"
	}

	onInput (value: any[]) {
		this.$emit("input", value)
	}
}

